import InterestUri from '../Enum/InterestUri';

export const getPageTitleBySection = (section: InterestUri): string => {
    switch (section) {
        case InterestUri.Product:
            return 'Hypotheekrentes per product | Producten';
        case InterestUri.MarketValue:
            return 'Hypotheekrentes o.b.v. marktwaarde | Producten';
        case InterestUri.FixedPeriod:
            return 'Hypotheekrentes o.b.v. rentevast periode | Producten';
        case InterestUri.PropertiesPerLabel:
            return 'Hypotheekvoorwaarden per product | Producten';
        case InterestUri.PropertiesPerProperty:
            return 'Hypotheekvoorwaarden o.b.v. voorwaarden | Producten';
        case InterestUri.InterestNews:
            return 'Rente updates per product | Producten';
        case InterestUri.BridgingLoan:
            return 'Overbruggingskrediet | Producten';
        case InterestUri.PropertiesNews:
            return 'Hypotheekvoorwaarden updates per product | Producten';
        default:
            return 'Producten';
    }
};
